export default __webpack_public_path__ + "static/media/desacerdas.7a35c546.png";